import http_service from "../classes/http";
import { bus } from '../other/bus'

let http = new http_service(bus);

export default {
  namespaced: true,
  state: {
    trainers: [],
    gorbov_params: {
      start: false,
      finish: false,
      size: 3,
      show_reactions: false
    },
    mnemo_params: {
      get_ready: false,
      start: false,
      finish: false,
      size: 3,
      show_reactions: false
    },
    bee_params: {
      start: false,
      finish: false,
      show_reactions: false,
      size: 3,
      min_steps: 3,
      max_steps: 5,
      speed: 0.5,
      mode: 'where',
      sounds: true,
      users: 1
      // modes - out, where, path
    },
    abacus_params: {
      start: false,
      finish: false,
      show_numbers: true,
      num_axis: 3,
      axises: '',
      show_reactions: false
    },
    flash_params: {
      start: false,
      finish: false,
      direct_to: 9,
      from: 1,
      to: 1,
      speed: 1,
      direction: false,
      mode: 'train',
      users: 1,
      show_reactions: false,
      qnt: 1
    },
    multi_params: {
      start: false,
      finish: false,
      qnt: 1,
      first: {
        digits: 1,
        first: [],
        second: []
      },
      second: {
        digits: 1,
        first: [],
        second: []
      },
      type: 'multi',
      mirror: false,
      hasRemainder: false,
      remainderAnswer: false,
      digitsRemainder: 1,
      mode: 'train',
      users: 1,
      show_reactions: false
    },
    mental_params: {
      start: false,
      finish: false,
      formula: 0,
      cifers: [],
      cifers_dop: [],
      rank: '1/9',
      speed: 1,
      terms: 3,
      steps: 1,
      users: 1,
      direct_to: 9,
      show_reactions: false,
      voice: false,
      sounds: 'sound'
    },
    columns_params: {
      start: false,
      finish: false,
      formula: 0,
      cifers: [],
      cifers_dop: [],
      rank: '1/9',
      direct_to: 9,
      speed: 1,
      terms: 3,
      qnt: 1,
      users: 1,
      show_reactions: false
    }

  },
  mutations: {
    changeGorbovParams(store, val) {
      store.gorbov_params[val.param_name] = val.param_val;
    },
    changeMnemoParams(store, val) {
      store.mnemo_params[val.param_name] = val.param_val;
    },
    changeAbacusParams(store, val) {
      store.abacus_params[val.param_name] = val.param_val;
    },
    changeFlashParams(store, val) {
      store.flash_params[val.param_name] = val.param_val;
    },
    changeMultiParams(store, val) {
      store.multi_params[val.param_name] = val.param_val;
    },
    changeMentalParams(store, val) {
      store.mental_params[val.param_name] = val.param_val;
    },
    changeColumnsParams(store, val) {
      store.columns_params[val.param_name] = val.param_val;
    },
    changeParams(store, val) {
      store[val.train] = val.params;
    },
    changeParam(store, val) {
      store[val.train][val.param_name] = val.param_val;
    },
    setTrainers(state, items) {
      state.trainers = items;
    }
  },
  actions: {
    getTrainers(ctx) {
      http.post('onGetTrainers').then(res => {
        let trainers = res.data       

        ctx.commit('setTrainers', trainers);
      })      
    }
  },
  getters: {
    trainers(state) {
      return state.trainers
    },
    trainerByName(state) {
      return (component) => {
        return state.trainers.find(item => item.component === component)
      }
    },
  }
}